<template>
  <!-- Modal for updating password  -->
  <j-dialog
    dialog-name="check-mailbox"
    :value="$dialog.status('check-mailbox')"
    title="Checking Mailbox..."
    max-width="50%"
    @cancel="handleCloseDialog"
  >
    <j-card-text>
      <j-alert
        v-if="error"
        type="error"
        message="Error checking mailbox."
      />
      <j-alert
        v-else-if="loaded"
        type="success"
        message="Mailbox checked successfully."
      />
      <v-progress-linear
        v-else
        indeterminate
        color="primary"
        class="mb-4"
      />
    </j-card-text>

    <!-- Actions -->
    <template #actions>
      <!-- Close -->
      <j-button
        label="Close"
        :disabled="!loaded"
        @action="handleCloseDialog"
      />
    </template>
  </j-dialog>
</template>

<script>

// Components

// Vuex
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('staff')

export default {
  name: 'CheckMailboxDialog',
  data () {
    return {
      error: false,
      loaded: false
    }
  },
  computed: {
    ...mapState([
      'contact'
    ]),
    dialogStatus() {
      return this.$dialog.status('check-mailbox')
    }
  },
  // ----------
  // Methods ==
  // ----------
  methods: {
    ...mapActions([
      'checkMailbox',
    ]),
    handleCloseDialog () {
      this.$dialog.close('check-mailbox')
    },
    handleCheckMailbox() {
      this.checkMailbox().catch(() => {
        this.error = true
      }).finally(() => {
        this.loaded = true
      })
    }
  },
  watch: {
    dialogStatus: {
      handler(value) {
        if (value) {
          // Dialog is open, check the mailbox
          this.handleCheckMailbox()
        } else {
          // Dialog is closed, reset the state
          this.error = false
          this.loaded = false
        }
      }
    }
  }
}
</script>
